import clsx from "classnames";
import { Spinner } from "../Spinner/Spinner";

export const Loading = ({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) => (
  <div className={clsx("absolute left-0 top-0 z-10 flex h-full w-full items-center justify-center bg-white/90", className)} {...props}>
    <Spinner className="!m-0 h-6 w-6" />
  </div>
);
